import { GlobalStyle } from "./globalStyles";
import { GlobalVariables } from "./globalVariables";
import { Helmet } from "react-helmet";

export const FontLinks = () => (
	<Helmet>
		<link
			href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300..700&display=swap"
			rel="stylesheet"
		/>
		<link
			href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"
			rel="stylesheet"
		/>
		<link
			href="https://fonts.googleapis.com/css2?family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700&display=swap"
			rel="stylesheet"
		/>
	</Helmet>
);

export const StyleProvider = ({ children }) => {
	return (
		<>
			<FontLinks />
			<GlobalStyle />
			<GlobalVariables />
			{children}
		</>
	);
};
